import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import AuthService from '../../services/auth.service';

const AppNavbar = () => {
  const navigate = useNavigate();
  const currentUser = AuthService.getCurrentUser();
  const isAdmin = AuthService.isAdmin();

  const handleLogout = (e) => {
    e.preventDefault();
    AuthService.logout();
    navigate('/login');
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">AsegurAgua</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {currentUser && (
              <>
                <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
                {isAdmin && (
                  <>
                    <Nav.Link as={Link} to="/upload">Subir Datos</Nav.Link>
                  </>
                )}
              </>
            )}
          </Nav>
          <Nav>
            {currentUser ? (
              <>
                <Navbar.Text className="me-3">
                  {currentUser.email} | {currentUser.role === 'administrador' ? 'Admin' : 'Ciudadano'}
                </Navbar.Text>
                <Nav.Link href="#" onClick={handleLogout}>Cerrar Sesión</Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login">Iniciar Sesión</Nav.Link>
                <Nav.Link as={Link} to="/register">Registrarse</Nav.Link>
                <Nav.Link href="#" onClick={handleLogout}>Cerrar Sesión</Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;